<div class="filter-wrapper w-100 mb-4">
  <mat-accordion class="filter-accordion">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>filter_alt</mat-icon>
          Filtri
        </mat-panel-title>
        <mat-panel-description> </mat-panel-description>
      </mat-expansion-panel-header>
      <div [formGroup]="searchFilter" class="w-100" class="row">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'common.search_by_name' | translate }}</mat-label>
            <input formControlName="term" matInput type="text" #MapsAutocomplete />
            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearDefaultSearchFilter()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'map.sidebar.raccordo-cavo.form.data_verbale' | translate }}</mat-label>
            <input formControlName="data_verbale" [matDatepicker]="picker" matInput />
            <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <div class="buttons-wrapper">
    <button
      mat-mini-fab
      color="primary"
      *ngIf="userCanCreate"
      (click)="openRaccordoCavoModal()"
      [matTooltip]="'map.sidebar.raccordo-cavo.create' | translate"
      matTooltipPosition="above"
    >
      <mat-icon>add</mat-icon>
    </button>

    <button
      mat-mini-fab
      color="accent"
      [matMenuTriggerFor]="menu"
      [matTooltip]="'map.map_table.export' | translate"
      matTooltipPosition="above"
    >
      <mat-icon>download</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="onExport('html')">
        {{ 'map.map_table.export_html' | translate }}
      </button>
      <button mat-menu-item (click)="onExport('csv')">
        {{ 'map.map_table.export_csv' | translate }}
      </button>
    </mat-menu>
  </div>
</div>

<div class="map-table-content">
  <mtx-grid
    #grid
    [data]="dataGrid"
    [columns]="columnsGrid"
    [showColumnMenuHeader]="false"
    [noResultText]="'common.no_result' | translate"
    [showFirstLastButtons]="false"
    [rowStriped]="true"
    [showPaginator]="true"
    [emptyValuePlaceholder]="'-'"
    [pageSize]="pageSize"
    [pageOnFront]="false"
    [pageIndex]="currentPageIndex"
    [pageSizeOptions]="pageSizeOptions"
    [length]="totalCount"
    [sortOnFront]="false"
    [sortDisabled]="false"
    sortStart="asc"
    (sortChange)="onSortChange($event)"
    (page)="onPageChange($event)"
    [rowClassFormatter]="rowClassFormatter"
    [expandable]="true"
    [expansionTemplate]="expansionTpl"
  >
  </mtx-grid>

  <ng-template #expansionTpl let-row>
    <div class="d-flex flex-column expandable-wrapper">
      <dl>
        <dt>{{ 'map.sidebar.raccordo-cavo.form.building_name' | translate }}:</dt>
        <dd>{{ row.nome_edificio }}</dd>

        <dt>Id GIS:</dt>
        <dd>{{ row.id_gis }}</dd>

        <dt>{{ 'map.sidebar.raccordo-cavo.form.building_alias' | translate }}:</dt>
        <dd>{{ row.alias }}</dd>

        <dt>{{ 'map.sidebar.raccordo-cavo.form.gat_sede' | translate }}:</dt>
        <dd>{{ row.gat_sede }}</dd>

        <!-- <dt>{{'map.sidebar.raccordo-cavo.form.latitude' | translate}}:</dt>
        <dd>{{ row.latitudine }}</dd>

        <dt>{{'map.sidebar.raccordo-cavo.form.longitude' | translate}}:</dt>
        <dd>{{ row.longitude }}</dd> -->

        <dt>{{ 'map.sidebar.raccordo-cavo.form.data_verbale' | translate }}:</dt>
        <dd>{{ row.data_verbale }}</dd>

        <dt>{{ 'map.sidebar.raccordo-cavo.table.fattibilita' | translate }}:</dt>
        <dd>{{ row.codice_fattibilita }}</dd>

        <dt>{{ 'map.sidebar.raccordo-cavo.form.td_raccordo' | translate }}:</dt>
        <dd>{{ row.td_raccordo }}</dd>

        <dt>{{ 'map.sidebar.raccordo-cavo.form.nome_cavo' | translate }}:</dt>
        <dd>{{ row.nome_cavo }}</dd>

        <dt>{{ 'map.sidebar.raccordo-cavo.form.potenzialita_cavo' | translate }}:</dt>
        <dd>{{ row.potenzialita_cavo }}</dd>

        <dt>{{ 'map.sidebar.raccordo-cavo.form.potenzialita_iru' | translate }}:</dt>
        <dd>{{ row.potenzialita_iru }}</dd>

        <dt>{{ 'map.sidebar.raccordo-cavo.form.sala_1' | translate }}:</dt>
        <dd>{{ row.sala_1 }}</dd>

        <dt>{{ 'map.sidebar.raccordo-cavo.form.sala_2' | translate }}:</dt>
        <dd>{{ row.sala_2 }}</dd>

        <dt>{{ 'map.sidebar.raccordo-cavo.table.terminazione_1' | translate }}:</dt>
        <dd>{{ row.terminazione_1 }}</dd>

        <dt>{{ 'map.sidebar.raccordo-cavo.table.terminazione_2' | translate }}:</dt>
        <dd>{{ row.terminazione_2 }}</dd>
      </dl>
    </div>
  </ng-template>

  <ng-template #actionsTemplate let-row>
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="openRaccordoAttachmentsModal(row.id)">
        <mat-icon>attach_file</mat-icon>
        <span>{{ 'common.attachments' | translate }}</span>
      </button>
      <button mat-menu-item (click)="openFiberDetail(row)">
        <mat-icon>cable</mat-icon>
        <span>{{ 'map.sidebar.raccordo-cavo.table.fiber' | translate }}</span>
      </button>
      <button mat-menu-item (click)="openRaccordoCavoModal(row.id)" *ngIf="userCanEdit">
        <mat-icon>edit</mat-icon>
        <span>{{ 'common.modify' | translate }}</span>
      </button>
      <!-- solo per cavi virtuali -->
      <button mat-menu-item (click)="onDeleteCavoVirtuale(row.id)" *ngIf="userCanEdit && !row.id_gis">
        <mat-icon>delete</mat-icon>
        <span>{{ 'common.remove' | translate }}</span>
      </button>
    </mat-menu>
  </ng-template>

  <ng-template #geometryColTemplate let-row let-index="index" let-col="colDef">
    <button
      mat-icon-button
      color="primary"
      (click)="onCenterMapPlaceRequested($event, row)"
      [disabled]="!row.latitudine && !row.longitudine"
      [matTooltip]="'map.map_table.show_on_map' | translate"
    >
      <mat-icon>place</mat-icon>
    </button>
  </ng-template>
</div>
